import React from 'react';

/**
 * The inline pill that carries a step's subject, as in the mock:
 * a green "Aa variable" chip for a variable, an amber chip for a tool.
 *
 * An unset chip renders as a short dash rather than an empty pill, so an
 * unfinished step reads as unfinished instead of looking broken.
 */

const TONES = {
    variable: 'bg-emerald-100/80 text-emerald-900',
    tool: 'bg-amber-100/80 text-amber-900',
    plain: 'bg-gray-100 text-gray-700',
};

export default function StepChip({ tone = 'plain', value, mono = true, prefix }) {
    if (!value) {
        return <span className="inline-block w-6 border-b-2 border-amber-300 align-middle" />;
    }

    return (
        <span
            className={`inline-flex max-w-full items-center gap-1 rounded-md px-2 py-0.5 align-middle ${TONES[tone] || TONES.plain}`}
        >
            {prefix && <span className="text-[10px] font-semibold opacity-60">{prefix}</span>}
            <span className={`truncate ${mono ? 'font-mono text-[12.5px] font-semibold' : 'text-[12.5px]'}`}>
                {value}
            </span>
        </span>
    );
}
